import React from "react";
import { WideImageModel } from "../Models/PageCreatorPage";
import WideImageWrapper from "./WideImageWrapper";

interface FourWideImageProps {
  images: WideImageModel[];
}

const FourWideImage = ({ images }: FourWideImageProps) => {
  return (
    <div className="flex flex-col gap-4 rounded w-full xs:flex-row xs:flex-wrap sm:gap-6">
      {images.map((image) => {
        return (
          <WideImageWrapper
            image={image}
            className="rounded flex-[1_0_200px]"
            key={image.imageAltText}
          >
            <span className="sr-only">Shop All {image.imageAltText}</span>
            <img
              src={image.imageUrl}
              alt={image.imageAltText}
              className="rounded w-full"
            />
          </WideImageWrapper>
        );
      })}
    </div>
  );
};

export default FourWideImage;
